import React, { useContext } from 'react';
import classes from './SearchErrorBox.module.scss';
import { FindContentContext } from '../FindContentProvider';
import { Void } from '../../../../models/basic-objects';
import { Button } from '../../../../components/actions/Button';
import { ButtonColorsEnum } from '../../../../constants/button-colors';
import { useNavigate } from 'react-router-dom';

export type SearchErrorBoxViewProps = {
  apolloErrorKey: string | undefined;
  filterSearchHandler: (resetFilterBar?: boolean, ignoreStepIncrement?: boolean) => void;
};

const SearchErrorButton = ({ filterSearchHandler, apolloErrorKey }: SearchErrorBoxViewProps): JSX.Element => {
  const navigate = useNavigate();

  let action: Void;
  let label = '';

  switch (apolloErrorKey) {
    case 'SOCIAL_NETWORK_NOT_CONNECTED':
      action = () => navigate({ pathname: '/settings/profiles' });
      label = 'Re-connect Profile';
      break;

    default:
      action = () => filterSearchHandler(false, true);
      label = 'Try Again';
  }

  return (
    <Button type={'button'} variant={'hollow'} size={'small'} color={ButtonColorsEnum.alert} action={action}>
      <span>{label}</span>
    </Button>
  );
};
export const SearchErrorBoxView = (props: SearchErrorBoxViewProps): JSX.Element => {
  const { error } = useContext(FindContentContext);

  return (
    <div className={classes.SearchErrorBox}>
      <div>{error}</div>
      <div className={classes.ActionButtonContainer}>
        <SearchErrorButton {...props} />
      </div>
    </div>
  );
};
